import { Injectable } from "@angular/core";
import { globals } from "../utils/globals";
import { TranslateService } from "@ngx-translate/core";
import { environment } from "@environments/environment";

@Injectable()
export class UrlService {
  constructor(public translate: TranslateService, public globals: globals) {}

  /**
   * URL de acceso al Oauth.
   */
  //oauthURL: any = this.baseURL() + this.globals.constants.url_token;

  /**
   * Obtiene la URL base de acceso a la pasarela.
   */
  baseURL() {
    return environment.urlBaseBackoffice;
  }

  getOauthLoginURL() {
    return (
      this.baseURL() +
      this.globals.constants.url_api +
      this.globals.constants.url_oauth_login
    );
  }

  getOauthIsAutenticatedURL() {
    return (
      this.baseURL() +
      this.globals.constants.url_api +
      this.globals.constants.url_oauth_is_authenticated
    );
  }

  getRegisterFinalUserURL() {
    return (
      this.baseURL() +
      this.globals.constants.url_api +
      this.globals.constants.url_final_user +
      this.globals.constants.url_final_user_register
    );
  }

  getUpdateFinalUserURL() {
    return (
      this.baseURL() +
      this.globals.constants.url_api +
      this.globals.constants.url_final_user +
      this.globals.constants.url_final_user_update
    );
  }

  getDeleteUserURL() {
    return (
        this.baseURL() +
        this.globals.constants.url_api +
        this.globals.constants.url_final_user +
        this.globals.constants.url_final_user_delete
    );
  }

  getIsEmailAvailableFinalUserURL() {
    return (
      this.baseURL() +
      this.globals.constants.url_api +
      this.globals.constants.url_final_user +
      this.globals.constants.url_final_user_validate_email
    );
  }

  getIsNifAvailableFinalUserURL() {
    return (
        this.baseURL() +
        this.globals.constants.url_api +
        this.globals.constants.url_final_user +
        this.globals.constants.url_final_user_validate_nif
    );
  }

  getAddFinalUserResponseURL() {
    return (
      this.baseURL() +
      this.globals.constants.url_api +
      this.globals.constants.url_final_user_response +
      this.globals.constants.url_final_user_response_add
    );
  }

  getDeleteFinalUserResponseByQuestionIdURL() {
    return (
      this.baseURL() +
      this.globals.constants.url_api +
      this.globals.constants.url_final_user_response +
      this.globals.constants.url_final_user_response_delete_by_question
    );
  }

  getAddFinalUserAudioURL() {
    return (
      this.baseURL() +
      this.globals.constants.url_api +
      this.globals.constants.url_final_user_audio +
      this.globals.constants.url_final_user_audio_add
    );
  }

  getDeleteFinalUserAudioURL() {
    return (
      this.baseURL() +
      this.globals.constants.url_api +
      this.globals.constants.url_final_user_audio +
      this.globals.constants.url_final_user_audio_delete
    );
  }

  getAllFinalUserAudiosByUserIdURL() {
    return (
      this.baseURL() +
      this.globals.constants.url_api +
      this.globals.constants.url_final_user_audio +
      this.globals.constants.url_final_user_audio_get_by_user
    );
  }

  getGetQuestionsByStepURL() {
    return (
      this.baseURL() +
      this.globals.constants.url_api +
      this.globals.constants.url_questions +
      this.globals.constants.url_questions_step
    );
  }

  getAllQuestionsURL() {
    return (
      this.baseURL() +
      this.globals.constants.url_api +
      this.globals.constants.url_questions
    );
  }

  getFileUploadURL() {
    return (
      this.baseURL() +
      this.globals.constants.url_api +
      this.globals.constants.url_file +
      this.globals.constants.url_file_upload
    );
  }

  getFileDownloadURL() {
    return (
      this.baseURL() +
      this.globals.constants.url_api +
      this.globals.constants.url_file +
      this.globals.constants.url_file_download
    );
  }

  getForgotPasswordURL() {
    return (
      this.baseURL() +
      this.globals.constants.url_api +
      this.globals.constants.url_oauth_forgot_password
    );
  }

  getChangePasswordURL() {
    return (
      this.baseURL() +
      this.globals.constants.url_api +
      this.globals.constants.url_oauth_change_password
    );
  }

  getChangePasswordValidateTokenURL() {
    return (
      this.baseURL() +
      this.globals.constants.url_api +
      this.globals.constants.url_oauth_change_password +
      this.globals.constants.url_oauth_change_password_token_validation
    );
  }

  getAllFinalUsersOrderedURL() {
    return (
      this.baseURL() +
      this.globals.constants.url_api +
      this.globals.constants.url_final_user +
      this.globals.constants.url_final_user_index
    );
  }

  getCountAllUsers() {
    return (
        this.baseURL() +
        this.globals.constants.url_api +
        this.globals.constants.url_final_user +
        this.globals.constants.url_final_user_count
    );
  }

  getFinalUserSearchURL() {
    return (
      this.baseURL() +
      this.globals.constants.url_api +
      this.globals.constants.url_final_user +
      this.globals.constants.url_final_user_search
    );
  }

  getFinalUserResponsesInfoURL() {
    return (
      this.baseURL() +
      this.globals.constants.url_api +
      this.globals.constants.url_final_user_response +
      this.globals.constants.url_final_user_response_info_user
    );
  }

  getAllFinalUsersResponsesInfoURL() {
    return (
      this.baseURL() +
      this.globals.constants.url_api +
      this.globals.constants.url_final_user_response +
      this.globals.constants.url_final_user_response_info_user +
      this.globals.constants.url_final_user_response_multiple_users_info
    );
  }

  getUserByIdURL() {
    return (
      this.baseURL() +
      this.globals.constants.url_api +
      this.globals.constants.url_user +
      this.globals.constants.url_user_get_by_id
    );
  }
}
